<template>
  <header class="fixed top-0 left-0 right-0 z-50 transition-all duration-500" 
          :class="scrolled ? 'bg-white/95 backdrop-blur-xl shadow-lg shadow-black/5' : 'bg-transparent'">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-20">
        <div class="flex items-center">
          <a href="#" class="text-3xl font-bold font-display" :class="scrolled ? 'text-amber-600' : 'text-white'">
            <span>西明食品</span>
          </a>
        </div>
        
        <nav class="hidden lg:flex items-center space-x-10">
          <a v-for="item in navItems" :key="item.href" :href="item.href" 
             class="text-sm font-medium transition-all duration-300 relative group"
             :class="scrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white/90 hover:text-white'">
            {{ item.label }}
            <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-amber-500 transition-all duration-300 group-hover:w-full"></span>
          </a>
        </nav>
        
        <div class="hidden lg:flex items-center space-x-6">
          <a href="#contact" class="px-8 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm font-semibold rounded-full hover:opacity-90 transition-all duration-300 shadow-lg shadow-amber-500/30 hover:shadow-xl hover:shadow-amber-500/40 hover:scale-105">
            立即询价
          </a>
        </div>
        
        <button @click="mobileMenuOpen = !mobileMenuOpen" 
                class="lg:hidden p-2 -mr-2 rounded-lg transition-colors"
                :class="scrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'">
          <Menu v-if="!mobileMenuOpen" :size="26" />
          <X v-else :size="26" />
        </button>
      </div>
    </div>
    
    <div v-if="mobileMenuOpen" class="lg:hidden bg-white/95 backdrop-blur-xl border-t border-gray-100">
      <div class="px-6 py-6 space-y-4">
        <a v-for="item in navItems" :key="item.href" :href="item.href" 
           @click="mobileMenuOpen = false"
           class="block px-4 py-3 text-gray-700 hover:text-amber-600 hover:bg-amber-50 rounded-xl transition-all duration-300">
          {{ item.label }}
        </a>
        <div class="pt-4 border-t border-gray-100">
          <a href="#contact" @click="mobileMenuOpen = false" class="block w-full px-4 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl font-semibold hover:opacity-90 transition-all">立即询价</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Menu, X } from 'lucide-vue-next'

const scrolled = ref(false)
const mobileMenuOpen = ref(false)

const navItems = [
  { label: '首页', href: '#home' },
  { label: '关于我们', href: '#about' },
  { label: '产品中心', href: '#services' },
  { label: '企业实力', href: '#portfolio' },
  { label: '联系我们', href: '#contact' },
]

const handleScroll = () => {
  scrolled.value = window.scrollY > 80
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
